if($('html').hasClass('pro')){
  if(Cookies.get('pro-warning') == undefined){
    $('#pro-warning').modal();
  }

  $('#pro-warning').on('hide.bs.modal', function() {
    Cookies.set('pro-warning', true, { expires: 7 });
  });
}
